
const products = [
  {
    id: 1,
    title: 'Mutfak Dolabı',
    description: 'Modern ve fonksiyonel mutfak dolabı çözümleri. Özel ölçü ve tasarım seçenekleriyle mutfağınızı hayalinizdeki gibi düzenleyin.',
    image: 'https://public.readdy.ai/ai/img_res/3ab3508afe1fb7881b632557aa06d4d2.jpg',
    icon: 'ri-home-4-line'
  },
  {
    id: 2,
    title: 'Tüm Tezgah Çeşitleri',
    description: 'Granit, mermer, kompakt laminat ve ahşap tezgah seçenekleri. Dayanıklı ve estetik mutfak tezgahları ile mutfağınıza değer katın.',
    image: 'https://readdy.ai/api/search-image?query=Premium%20kitchen%20countertop%20display%20with%20marble%20granite%20and%20wooden%20surfaces%2C%20elegant%20modern%20design%2C%20professional%20craftsmanship%2C%20clean%20minimalist%20background%2C%20sophisticated%20lighting%2C%20luxury%20interior%20photography&width=600&height=400&seq=product-tezgah-2&orientation=landscape',
    icon: 'ri-layout-line'
  },
  {
    id: 3,
    title: 'Yüklük',
    description: 'Geniş ve düzenli depolama alanları sunan yüklük sistemleri. Evinizin her köşesine uygun özel tasarım yüklükler.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20built-in%20storage%20closet%20system%20with%20organized%20shelving%2C%20elegant%20wooden%20finish%2C%20contemporary%20design%2C%20spacious%20compartments%2C%20clean%20simple%20background%2C%20professional%20interior%20photography&width=600&height=400&seq=product-yukluk-3&orientation=landscape',
    icon: 'ri-door-line'
  },
  {
    id: 4,
    title: 'Gardırop',
    description: 'Şık ve kullanışlı gardırop sistemleri. Sürgülü, açılır kapılı ve açık gardırop modelleriyle kişisel tarzınızı yansıtın.',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20wardrobe%20closet%20system%20with%20sliding%20doors%2C%20modern%20wooden%20design%2C%20organized%20interior%2C%20elegant%20finish%2C%20spacious%20storage%2C%20clean%20simple%20background%2C%20professional%20furniture%20photography&width=600&height=400&seq=product-gardirop-4&orientation=landscape',
    icon: 'ri-shirt-line'
  },
  {
    id: 5,
    title: 'Vestiyer',
    description: 'Giriş holünüz için şık vestiyer çözümleri. Ayakkabılık, askılık ve ayna kombinasyonlarıyla fonksiyonel tasarımlar.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20entryway%20hallway%20furniture%20with%20coat%20rack%2C%20shoe%20storage%2C%20mirror%2C%20elegant%20wooden%20design%2C%20contemporary%20style%2C%20organized%20system%2C%20clean%20simple%20background%2C%20professional%20interior%20photography&width=600&height=400&seq=product-vestiyer-5&orientation=landscape',
    icon: 'ri-handbag-line'
  },
  {
    id: 6,
    title: 'Giyinme Odası',
    description: 'Lüks ve özel tasarım giyinme odası projeleri. Kişiye özel düzenlemeler ve premium malzemelerle hayalinizdeki giyinme odasına kavuşun.',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20walk-in%20closet%20dressing%20room%20with%20elegant%20wooden%20shelving%2C%20organized%20storage%20systems%2C%20modern%20lighting%2C%20premium%20design%2C%20spacious%20layout%2C%20clean%20simple%20background%2C%20high-end%20interior%20photography&width=600&height=400&seq=product-giyinme-6&orientation=landscape',
    icon: 'ri-t-shirt-line'
  },
  {
    id: 7,
    title: 'Yatak Odası Takımı',
    description: 'Uyumlu ve şık yatak odası takımları. Yatak, komodin, şifonyer ve gardırop kombinasyonlarıyla tam set çözümler.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20bedroom%20furniture%20set%20with%20elegant%20bed%2C%20nightstands%2C%20dresser%2C%20wardrobe%2C%20contemporary%20wooden%20design%2C%20coordinated%20style%2C%20clean%20simple%20background%2C%20professional%20furniture%20photography&width=600&height=400&seq=product-yatak-7&orientation=landscape',
    icon: 'ri-hotel-bed-line'
  },
  {
    id: 8,
    title: 'Raf Sistemleri',
    description: 'Dekoratif ve fonksiyonel raf sistemleri. Duvar rafları, kitaplık ve özel tasarım raf çözümleriyle mekanlarınızı düzenleyin.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20wall%20shelving%20system%20with%20elegant%20wooden%20design%2C%20contemporary%20bookshelf%2C%20organized%20display%2C%20minimalist%20style%2C%20functional%20storage%2C%20clean%20simple%20background%2C%20professional%20interior%20photography&width=600&height=400&seq=product-raf-8&orientation=landscape',
    icon: 'ri-stack-line'
  },
  {
    id: 9,
    title: 'Proje-Tasarım',
    description: 'Özel proje ve tasarım hizmetleri. Uzman ekibimizle hayalinizdeki mobilyaları 3D tasarımdan üretime kadar profesyonel çözümler.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20furniture%20design%20studio%20with%203D%20modeling%2C%20architectural%20drawings%2C%20material%20samples%2C%20modern%20workspace%2C%20design%20tools%2C%20creative%20process%2C%20clean%20simple%20background%2C%20professional%20photography&width=600&height=400&seq=product-proje-9&orientation=landscape',
    icon: 'ri-pencil-ruler-2-line'
  }
];

export default function Products() {
  return (
    <section id="products" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Ürün ve Hizmetlerimiz
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Kaliteli malzeme ve işçilikle üretilen mobilyalarımız, evinize estetik ve fonksiyonellik katıyor
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {products.map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300 cursor-pointer group"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 bg-amber-600 text-white w-12 h-12 flex items-center justify-center rounded-full">
                  <i className={`${product.icon} text-2xl`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {product.title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  {product.description}
                </p>
                <a
                  href="https://wa.me/905303030218"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-amber-700 font-semibold hover:text-amber-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  Detaylı Bilgi Al
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="https://wa.me/905303030218"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-green-600 text-white px-8 py-4 rounded-lg hover:bg-green-700 transition-colors duration-200 font-semibold text-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Teklif Almak İçin WhatsApp'tan Ulaşın
          </a>
        </div>
      </div>
    </section>
  );
}
